'use strict';

(function () {
    const states = new Map();
    const margin = 200;

    function canPlay(state) {
        return state.visible && !state.suspended && !document.hidden;
    }

    function load(state) {
        if (state.loaded || state.suspended || document.hidden) return;
        state.video.querySelectorAll('source[data-src]').forEach((source) => {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
        });
        state.loaded = true;
        state.video.preload = 'metadata';
        state.video.load();
    }

    function update(state) {
        const video = state.video;
        if (!canPlay(state)) {
            if (state.active) state.resume = !video.paused || state.pending;
            state.active = false;
            const pending = state.pending;
            state.playId++;
            state.pending = false;
            if (!video.paused || pending) video.pause();
            return;
        }

        const entering = !state.active;
        state.active = true;
        load(state);
        if (!entering || !state.resume || !video.paused) return;

        const playId = ++state.playId;
        state.pending = true;
        const playback = video.play();
        if (playback && typeof playback.then === 'function') {
            playback.then(() => {
                if (state.playId === playId) state.pending = false;
                if (!canPlay(state)) video.pause();
            }, () => {
                if (state.playId === playId) state.pending = false;
                // Keep the poster and native controls usable if autoplay is denied.
            });
        } else {
            state.pending = false;
        }
    }

    function measure(state) {
        const rect = state.video.getBoundingClientRect();
        const hasArea = rect.width > 0 && rect.height > 0;
        const horizontal = rect.right > 0 && rect.left < window.innerWidth;
        state.visible = hasArea && horizontal && rect.bottom > 0 && rect.top < window.innerHeight;
        state.near = hasArea && horizontal && rect.bottom > -margin && rect.top < window.innerHeight + margin;
    }

    const videos = document.querySelectorAll('video[data-lazy-video]');
    videos.forEach((video) => {
        states.set(video, {
            video: video, loaded: false, visible: false, near: false,
            suspended: false, active: false, pending: false, playId: 0,
            resume: video.hasAttribute('data-video-autoplay')
        });
    });

    window.copiaincollaVideos = {
        suspend(video) {
            const state = states.get(video);
            if (!state) return;
            state.suspended = true;
            update(state);
        },
        resume(video) {
            const state = states.get(video);
            if (!state) return;
            state.suspended = false;
            measure(state);
            if (state.near) load(state);
            update(state);
        }
    };

    if (!videos.length) return;

    function refresh() {
        states.forEach((state) => {
            measure(state);
            if (state.near) load(state);
            update(state);
        });
    }

    if ('IntersectionObserver' in window) {
        const preloadObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const state = states.get(entry.target);
                state.near = entry.isIntersecting;
                if (state.near) load(state);
                if (state.loaded) preloadObserver.unobserve(entry.target);
            });
        }, { rootMargin: margin + 'px 0px' });
        const visibilityObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const state = states.get(entry.target);
                state.visible = entry.isIntersecting && entry.intersectionRatio > 0;
                update(state);
            });
        }, { threshold: [0, 0.01] });
        videos.forEach((video) => {
            preloadObserver.observe(video);
            visibilityObserver.observe(video);
        });
    } else {
        let scheduled = false;
        const scheduleRefresh = () => {
            if (scheduled) return;
            scheduled = true;
            window.requestAnimationFrame(() => {
                scheduled = false;
                refresh();
            });
        };
        window.addEventListener('scroll', scheduleRefresh, { passive: true });
        window.addEventListener('resize', scheduleRefresh);
        refresh();
    }

    document.addEventListener('visibilitychange', refresh);
})();
